import axiosInstance from './axios';
import { buildAttributeList } from '../components/control-new-look/TestAttributesSubTab';

/** Load active test plan (attributes → steps, fields). */
export async function fetchTestPlan(controlUuid) {
  const resp = await axiosInstance.get(`/api/sox-controls/${controlUuid}/test-plan`);
  return resp.data;
}

/** Load the plan snapshot frozen at run creation (safe to call for in-progress runs). */
export async function fetchTestRunPlan(runId) {
  const resp = await axiosInstance.get(`/api/control-test-runs/${runId}/plan`);
  return resp.data;
}

/** Save attribute-first test plan. */
export async function saveTestPlan(controlUuid, { attributes, fields }) {
  const resp = await axiosInstance.put(`/api/sox-controls/${controlUuid}/test-plan`, { attributes, fields });
  return resp.data;
}

/** Build flat attribute list from API plan (mirrors buildAttributeList shape). */
export function attributesFromPlan(planData) {
  const attrs = planData?.attributes || [];
  return attrs.map((a, i) => ({
    id: a.id,
    ref: a.display_ref || String.fromCharCode(65 + i),
    label: a.label || '',
    description: a.description || '',
    key: a.id,
    procedure: (a.steps || []).map((s) => s.instruction).filter(Boolean).join('\n'),
    steps: a.steps || [],
    stepIndex: i,
    attrIndex: 0,
  }));
}

/** Convert test_steps JSON to plan save payload.
 *
 * Each test_step becomes ONE attribute. The step's key_points[] become the
 * procedure steps for that attribute. step._text/summary is the attribute description.
 *
 * Note: test_attributes[] nested inside a step are field-mapping metadata, NOT
 * separate plan attributes — they are intentionally ignored here.
 */
export function testStepsToPlanPayload(testSteps, fields = []) {
  const attributes = (testSteps || []).map((step, i) => {
    const ref = step.ref || String.fromCharCode(65 + i);
    const desc = step._text || step.summary || step.description || '';
    const kp = (Array.isArray(step.key_points) ? step.key_points : []).filter(Boolean);
    return {
      id: step.id || step.key || undefined,
      display_ref: ref,
      label: step.label || desc,
      description: desc,
      steps: kp.length > 0
        ? kp.map((instruction, j) => ({ step_number: j + 1, instruction: String(instruction) }))
        : desc ? [{ step_number: 1, instruction: desc }] : [],
    };
  });

  return {
    attributes,
    fields: (fields || []).map((f, i) => ({
      id: f.id,
      field_key: f.id || f.label,
      label: f.label,
      description: f.description || '',
      pass_condition: f.pass_condition || '',
      applies_to_all: (f.attribute_ids || []).length === 0,
      attribute_ids: f.attribute_ids || [],
      sort_order: i,
    })),
  };
}
